// src/layout/Header.tsx
import React from "react";
import styled from "styled-components";
import { LogoutOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

import { clearTokens, getAccessToken } from "src/utils/auth";
import { myTheme } from "src/styles/GlobalStyle";

// ✅ 네가 만든 logout API import
import { logoutApi, delegateLogoutApi } from "src/api/auth/authApi";
import { jwtDecode } from "jwt-decode";

const routeTitleMap: Record<string, string> = {
  "/": "대시보드",
  "/challenge": "챌린지",
  "/healthcare": "설치헬스케어 기준정보",
};

const Header = () => {
  const location = useLocation();
  const decoded_ac = jwtDecode(getAccessToken() || "");
  // console.log(decoded_ac);
  const handleLogout = async () => {
    try {
      const loginType = localStorage.getItem("loginType");
      if (loginType === "delegate") {
        await delegateLogoutApi();
      } else {
        await logoutApi();
      }
    } catch (e) {
      console.error("logoutApi failed:", e);
    } finally {
      // localStorage 정리
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userName");
      localStorage.removeItem("loginType");
      clearTokens();
      window.location.replace("/login");
    }
  };

  const title = routeTitleMap[location.pathname] ?? "";
  return (
    <HeaderWrapper>
      <PageTitle>{title}</PageTitle>
      <UserSection>
        {decoded_ac && <MailBox>{(decoded_ac as any).email}</MailBox>}
        <LogoutButton onClick={handleLogout}>
          <LogoutOutlined />
          Logout
        </LogoutButton>
      </UserSection>
    </HeaderWrapper>
  );
};

export default Header;

// --- styles ---
const HeaderWrapper = styled.header`
  height: 64px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid #e0e0e0;
`;

const PageTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LogoutButton = styled.button`
  background-color: ${myTheme.colors.primary};
  color: white;
  border: none;
  padding: 3px 12px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 13px;
  height: 33px;

  svg {
    margin-right: 6px;
    font-size: 16px;
  }

  &:hover {
    background-color: rgb(72, 72, 72);
  }
`;

const MailBox = styled.span`
  border: 1.5px solid #ddd;
  padding: 6px 12px;
  border-radius: 50px;
  font-size: 13px;
`;
